var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.97,
    height: 21.89,
    viewBox: "0 0 21.97 21.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search-chart"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.3,11.4A10.18,10.18,0,0,1,11.5,1.2,10.33,10.33,0,0,1,21.8,11.4,10.26,10.26,0,0,1,11.5,21.6,10.12,10.12,0,0,1,1.3,11.4Zm1.5,0a8.8,8.8,0,1,0,8.8-8.8A8.81,8.81,0,0,0,2.8,11.4Z",
    transform: "translate(-1 -0.9)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.6,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5,22.4l-2-2a.78.78,0,0,1,1.1-1.1l2,2a.78.78,0,0,1,0,1.1c-.2.1-.3.2-.5.2A.45.45,0,0,1,21.5,22.4Z",
    transform: "translate(-1 -0.9)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Capa_118",
    "data-name": "Capa 118"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.1,8.2c.1,2.4.1,4.8.2,7.2l10-.2v-.3l-9.8.2V8.2Z",
    transform: "translate(-1 -0.9)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.6,12.8H9.1V10.2h.5Z",
    transform: "translate(-1 -0.9)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3,11.8h-.5V9.2h.5Z",
    transform: "translate(-1 -0.9)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,12.8h-.5V10.2H15Z",
    transform: "translate(-1 -0.9)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.91,6.72",
    transform: "translate(-1 -0.9)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchChart);
export default __webpack_public_path__ + "static/media/search-chart.0e9b6b5d760b1ba45da6cc3ed59fe175.svg";
export { ForwardRef as ReactComponent };